module.exports = __webpack_public_path__ + "img/3.b03fcfd3.png";